// core/skeletons.js — componentes de loading que preservam layout.
//
// Filosofia: em vez de mostrar "Carregando...", desenhamos um esqueleto
// cinza com o mesmo tamanho/forma aproximada do conteúdo real. Quando a
// resposta chega, a troca parece instantânea (sem "pulo" de layout) e a
// percepção de velocidade aumenta.
//
// Todos os skeletons usam a animação `eloq-skel-shimmer` definida em
// `styles/components/skeletons.css` (injetada pelo index.css).
//
// Exporta:
//   skelBlock(height)          — uma barra cinza animada, HTML string
//   skelList({rows, rowHeight, gap})   — lista vertical
//   skelTabs(n)                — fileira de abas cinza
//   skelTable({rows, cols})    — grade de células
//   skelCard                   — cartão grande (ex.: cabeçalho de turma)

const BAR = (h, extra = '') => `
  <div class="eloq-skel" style="height:${h}px;${extra}"></div>`;

/** Uma barra cinza animada com altura configurável. */
export function skelBlock(height = 16, extra = '') {
  return BAR(height, extra);
}

/**
 * Lista vertical de barras — ideal para listas de alunos, registros, etc.
 * rows=4, rowHeight=56, gap=10 equivale a ~4 cards empilhados.
 */
export function skelList({ rows = 4, rowHeight = 56, gap = 10 } = {}) {
  const items = Array.from({ length: rows }, () =>
    BAR(rowHeight, `border-radius:12px`)
  ).join('');
  return `<div style="display:flex;flex-direction:column;gap:${gap}px">${items}</div>`;
}

/** Fileira de N abas cinza, para skeletons de `.tab-bar`. */
export function skelTabs(n = 3) {
  const tabs = Array.from({ length: n }, () =>
    `<div class="eloq-skel" style="flex:1;height:34px;border-radius:8px"></div>`
  ).join('');
  return `<div style="display:flex;gap:8px">${tabs}</div>`;
}

/**
 * Grade de células (linhas × colunas) — para tabelas como a grade de
 * frequência admin. A primeira coluna é mais larga (nome do aluno).
 */
export function skelTable({ rows = 6, cols = 8 } = {}) {
  const header = `
    <div style="display:flex;gap:6px;margin-bottom:8px">
      <div class="eloq-skel" style="flex:2;height:20px;border-radius:4px"></div>
      ${Array.from({ length: cols - 1 }, () =>
        `<div class="eloq-skel" style="flex:1;height:20px;border-radius:4px"></div>`
      ).join('')}
    </div>`;
  const body = Array.from({ length: rows }, () => `
    <div style="display:flex;gap:6px;margin-bottom:6px">
      <div class="eloq-skel" style="flex:2;height:32px;border-radius:6px"></div>
      ${Array.from({ length: cols - 1 }, () =>
        `<div class="eloq-skel" style="flex:1;height:32px;border-radius:6px"></div>`
      ).join('')}
    </div>`).join('');
  return `<div>${header}${body}</div>`;
}

/** Cartão grande (usado em cabeçalhos de detalhe). */
export function skelCard(height = 120) {
  return `<div class="eloq-skel" style="height:${height}px;border-radius:16px"></div>`;
}
